import { render, staticRenderFns } from "./left_sale_list.vue?vue&type=template&id=1c36d11e&scoped=true&"
import script from "./left_sale_list.vue?vue&type=script&lang=js&"
export * from "./left_sale_list.vue?vue&type=script&lang=js&"
import style0 from "./left_sale_list.vue?vue&type=style&index=0&id=1c36d11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36d11e",
  null
  
)

export default component.exports